import { createContext } from 'react';
import { EventManager } from '../event-manager';

export const GlobalEventManagerContext = createContext<EventManager>(new EventManager());
export const GlobalEventManagerConsumer = GlobalEventManagerContext.Consumer;
